// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"uk","side":"vk","boxNumSelection":"wk","disabled":"xk","boxInfoMsg":"yk","noReturnItems":"zk"};